// CRM helpers — types, status computation, formatting.
export const CRM_TYPES = [
  "casting_director",
  "director",
  "producer",
  "casting_assistant",
  "screenwriter",
  "agent",
  "agent_uk",
  "other",
];

export const AUDITION_TYPES = [
  "in_person",
  "self_tape",
  "online_live",
  "callback_in_person",
  "callback_online",
  "chemistry_read",
  "screen_test",
  "final_audition",
  "other",
];

export const AUDITION_STATUSES = [
  "new", "in_preparation", "sent", "callback", "booked", "not_booked",
];

export const AUDITION_SCENE_STATUSES = ["to_prepare", "in_progress", "ready"];

export const CRM_INTERACTION_KINDS = [
  { key: "email", icon: "Mail" },
  { key: "phone", icon: "Phone" },
  { key: "message", icon: "MessageSquare" },
  { key: "meeting", icon: "Handshake" },
  { key: "casting", icon: "Clapperboard" },
  { key: "materials", icon: "Paperclip" },
];

export const CRM_FOLLOWUP_PRESETS = [30, 60, 90, 120, 180];

/**
 * daysDelta(followup_at) → integer days.
 * Positive: days remaining until follow-up.
 * 0: due today (or within the current calendar day).
 * Negative: days overdue.
 */
export function daysDelta(followupAt) {
  if (!followupAt) return null;
  const now = new Date();
  const target = new Date(followupAt);
  // Normalize to date-day boundary (UTC midnight of each)
  const a = Date.UTC(target.getUTCFullYear(), target.getUTCMonth(), target.getUTCDate());
  const b = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
  return Math.round((a - b) / (24 * 60 * 60 * 1000));
}

export function statusOf(followupAt) {
  const d = daysDelta(followupAt);
  if (d === null) return { key: "active", color: "green", dot: "🟢" };
  if (d <= 0) return { key: "today", color: "red", dot: "🔴" };
  if (d <= 7) return { key: "soon", color: "yellow", dot: "🟡" };
  return { key: "active", color: "green", dot: "🟢" };
}

export function bucketOf(followupAt) {
  const d = daysDelta(followupAt);
  if (d === null) return "later";
  if (d <= 0) return "today";
  if (d <= 7) return "upcoming";
  return "later";
}

export function formatCountdown(followupAt, t) {
  const d = daysDelta(followupAt);
  if (d === null) return "—";
  if (d === 0) return t("crm.countdown.today");
  if (d < 0) return t("crm.countdown.overdue").replace("{n}", Math.abs(d));
  return t("crm.countdown.days_left").replace("{n}", d);
}

export function formatDate(iso, lang) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString(lang === "pl" ? "pl-PL" : "en-US", {
      year: "numeric", month: "short", day: "numeric",
    });
  } catch { return "—"; }
}

export function fullName(c) {
  return [c.first_name, c.last_name].filter(Boolean).join(" ").trim() || "—";
}
